import React, { useState, useEffect } from "react";
import { Row, Col, Container, Button} from "react-bootstrap";
import { useParams } from 'react-router-dom';
import authService from "../services/authServices";
import "../css/Event.css"

const Event = () => {
  const [Post, setPost] = useState({ title: "", name: "", content: ""});
  const [showPosts, setShowPosts] = useState([]);
  const { id } = useParams();
  const [event, setEvent] = useState(false);
  const handleCreatePost = () => {
    setEvent(true);

  }
  const createPost = () => {
    authService.createPost(Post).then((res) => {
        if (res.data.error) {
            alert(res.data.error);
        } else {
            alert("Post created successfully");
            window.location.reload();
        }
    }
    );
  };
  
    // const navigate = useNavigate();
    // const handleClick = id => () => {
    //     navigate(`/update/${id}`);
    // }
    useEffect(() => {
      authService.getPosts().then((res) => {
          if (res.data.error) {
              alert(res.data.error);
          }
          setShowPosts(res.data);
      });
  }, []);
  const delPost = (_id) => () => {
    authService.deletePost(_id).then((res) => {
        console.log(res)
        if (res.data.error) {
            alert(res.data.error);
        } else {
            alert("Post deleted successfully");
            window.location.reload();
        }
    })
}
return(
  <div style={{paddingTop:"200px"}}>
    <div className="event-button">
    <button onClick={handleCreatePost}>
      Click here
    </button>
    </div>
{event ? (
  <div>
   <Row className="contact-bottom">
    <div>
      <h1>
      Your Event
      </h1>
    <input
      type="text"
      placeholder="Enter title here"
      name="title" 
      onChange={(e) => setPost({ ...Post, title: e.target.value })}
      />
    </div>
   </Row>
   <Row className="contact-bottom">
    <div>
      <h2>
      By
      </h2>
    <input
      type="text"
      placeholder="Enter title here"
      name="name" 
      onChange={(e) => setPost({ ...Post, name: e.target.value })}
      />
    </div>
   </Row>
   <Row className="contact-bottom">
    <div>
      <h2>
      Description
      </h2>
    <textarea
      type="text"
      className="form-control"
      placeholder="Enter title here"
      name="title" 
      style={{ maxHeight: "500px", width: "500px" }}
      onChange={(e) => setPost({ ...Post, content: e.target.value })}
      />
    </div>
   </Row>
   <Row className="contact-bottom">
    <div>
      <button onClick={createPost}>
        Create Event
      </button>
    </div>
   </Row>
  </div>
) : (
  <>
  <Row className="contact-bottom">
    <h1>
    Click here to create your event
    </h1>
  </Row>
  <Row className="contact-bottom">
    <Container className="contact-bottom">
                {showPosts.map((Posts, index) => (
                    // <Col key={index} style={{ width: "100%" }}>

                    // <Row style={{ display: "inline-flex" }}>
                    <Col className="display_box">
                        <Col>
                            {/* <Button onClick={handleClick(Posts._id)}> */}
                                {/* <img
                                    style={{ width: "500px" }}
                                    src={Posts.picture[0].url}
                                    alt="cover"

                                /> */}
                            {/* </Button> */}
                            <p >{Posts.title}</p>
                            <p >{Posts.content}</p>
                            {/* <span style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", width: "15px", display: "inline-block" }}>{Posts.content}</span> */}

                            <p><i> By: {Posts.name}</i></p>
                        </Col>
                        <button onClick={delPost(Posts._id)}>
                                            Delete
                        </button>
                    </Col>
                    // </Row>
                 

                ))}
            </Container>
            
  </Row>
 
</>
)}
</div>
);
}

export default Event;
